import type { FC, HTMLAttributes, Ref } from 'react'

import RhapHoverTooltip from '~/components/common/RhapHoverTooltip'
import MembershipIcon from '~/components/dashboard/soapV2/order/MembershipIcon'

interface MembershipIconWithTooltipProps {
  className?: string
  coveredByWplan: boolean
  tooltipText: string
}

const MembershipIconWithTooltip: FC<MembershipIconWithTooltipProps> = ({
  className,
  coveredByWplan,
  tooltipText,
}) => {
  const renderTrigger = (
    triggerProps: HTMLAttributes<HTMLSpanElement> & {
      ref: Ref<HTMLElement>
    },
  ) => (
    <span {...triggerProps}>
      <MembershipIcon className={className} limitReached={!coveredByWplan} />
    </span>
  )

  return (
    <RhapHoverTooltip
      content={tooltipText}
      enabled={coveredByWplan}
      placement="top"
      trigger={renderTrigger}
    />
  )
}

export default MembershipIconWithTooltip
